import React from "react";

const AboutSection = () => {
  return (
    <section id="about" className="about section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Sobre nosotros</h2>
          <h3>
            Conocé más <span>sobre nosotros</span>
          </h3>
          <p>
            Somos una plataforma dedicada a facilitar la organización de torneos
            deportivos al encontrar el mejor momento y lugar para los equipos,
            de manera rápida y eficiente.
          </p>
        </div>
        <div className="row">
          <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
            {/* <img
              src="../../assets/img/about.jpg"
              className="img-fluid"
              alt="Imagen"
            /> */}
            <div className="div-con-imagen" data-aos="fade-right"></div>
          </div>
          <div
            className="col-lg-6 pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <ul>
              <li>
                <i className="bx bx-store-alt"></i>
                <div>
                  <h5>Agilizando Planificación de Torneos</h5>
                  <p>
                    <p>
                      Nuestra misión es simplificar el proceso de programación
                      de torneos deportivos, ayudando a los organizadores a
                      encontrar la fecha y el lugar ideales para que los equipos
                      participantes puedan tener la mejor disponibilidad.
                    </p>
                  </p>
                </div>
              </li>
              <li>
                <i className="bx bx-images"></i>
                <div>
                  <h5>Ahorra Tiempo en la Organización</h5>
                  <p>
                    <p>
                      Con nuestra plataforma, puedes ahorrar tiempo valioso al
                      evitar largas negociaciones y búsquedas infructuosas.
                      Utilizamos tecnología avanzada para analizar múltiples
                      variables y ofrecerte las mejores opciones en cuestión de
                      minutos.
                    </p>
                  </p>
                </div>
              </li>
            </ul>
            {/* <p>
              Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
              irure dolor in reprehenderit in voluptate velit esse cillum dolore
              eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
              proident, sunt in culpa qui officia deserunt mollit anim id est
              laborum
            </p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
